<xng-breadcrumb [autoGenerate]="autoGenerateLabel"
                [preserveFragment]="preserveFragment"
                [preserveQueryParams]="preserveQueryParams"
                [separator]="separator">
</xng-breadcrumb>

